let routes = [
    {
        path: '/complain/personal/:id/:bi',
        name: 'complain-personal',
        meta: {
            title: '投诉个人',
            company: true
        },
        component: () => import('../views/complain/personal')
    },
    {
        path: '/complain/group/:id/:bi/:name',
        name: 'complain-group',
        meta: {
            title: '群投诉',
            company: true
        },
        component: () => import('../views/complain/group')
    },
    {
        path: '/complain/form/:type/:id/:bi/:reason/:name?',
        name: 'complain-form',
        meta: {
            title: '投诉',
            company: true
        },
        component: () => import('../views/complain/form')
    },
    {
        path: '/complain/notice',
        name: 'complain-notice',
        meta: {
            title: '投诉通知',
            company: true
        },
        component: () => import('../views/complain/notice')
    },
    {
        path: '/complain/result/:type/:id',
        name: 'complain-result',
        meta: {
            title: '投诉结果',
            company: true
        },
        component: () => import('../views/complain/result')
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '数企-注册',
            company: true
        },
        component: () => import('../views/register/index')
    }
];

export default routes;
